import { formatDate, pluralize } from '@travelata-libs/utils';
import { getCheckOut, parseDate, type StayDates } from '@/entities/searchCriteria';
import { flexCountWord } from './formatDateLabel';
import { DATE_FROM_TEXTS, STAY_DATES_TEXTS } from '../config/texts';

const NIGHTS_FORMS = ['ночь', 'ночи', 'ночей'];

export function formatNights(nights: number): string {
  return pluralize(NIGHTS_FORMS, nights);
}

function formatDayMonth(date: Date): string {
  return formatDate(date, 'dd.MM');
}

export function formatStayPeriod(checkIn: Date, checkOut: Date): string {
  const { valuePrefix, rangeJoin } = DATE_FROM_TEXTS;
  return `${valuePrefix}${formatDayMonth(checkIn)}${rangeJoin}${formatDayMonth(checkOut)}`;
}

export function formatStayValue(stay: StayDates): string {
  const period = formatStayPeriod(parseDate(stay.checkIn), parseDate(getCheckOut(stay)));
  const flexible = stay.flexible > 0 ? ` ${DATE_FROM_TEXTS.flexSign}${flexCountWord(stay.flexible)}` : '';
  return `${period}, ${formatNights(stay.nights)}${flexible}`;
}

export function formatPendingValue(checkInIso: string): string {
  return `${DATE_FROM_TEXTS.valuePrefix}${formatDayMonth(parseDate(checkInIso))}, ${STAY_DATES_TEXTS.pickCheckOut}`;
}
